import React, { ReactNode, Dispatch, SetStateAction, createContext, useState, useMemo } from "react";

import { IToast } from "../interfaces/toast";

const ValueContext = createContext({
    toasts: [] as IToast[],
    setToasts: {} as Dispatch<SetStateAction<IToast[]>>,
});

interface Props {
    children?: ReactNode
};

export const ValueProvider = ({ children }: Props) => {

    const [toasts, setToasts] = useState<IToast[]>([]);

    const value = useMemo(() => ({
        toasts, setToasts
    }), [toasts, setToasts]);

    return (
        <ValueContext.Provider value={value}>
            {children}
        </ValueContext.Provider>
    );
};

export default ValueContext;